export default {
  disableAll: {
    updated: (el, binding) => {
      if (!binding.value) return;
      const tags = ["input", "textarea", "select"];
      tags.forEach(tagName => {
        const nodes = el.getElementsByTagName(tagName);
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].id !== 'date_dismission') {
            nodes[i].disabled = true;
            nodes[i].tabIndex = -1;
          }
        }
      });
      
      // Disable Vue components (like InputSelect)
      const vueComponents = el.querySelectorAll('.multiselect, .dropdown');
      vueComponents.forEach(component => {
        component.classList.add('is-disabled');
        component.style.pointerEvents = 'none';
        component.style.opacity = '0.6';
        component.setAttribute('aria-disabled', 'true');
      });
    }
  }
}